module.exports = __webpack_public_path__ + "img/man-zm.071c4692.png";